var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section warehousing-detail" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "left",
            "show-message": false,
            disabled: _vm.isLook
          }
        },
        [
          _c(
            "el-collapse",
            { attrs: { value: _vm.collapse } },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "仓库信息", name: 1 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "进仓编号",
                                required: "",
                                prop: "warehouseNo"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.warehouseNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "warehouseNo", $$v)
                                  },
                                  expression: "form.warehouseNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "通知单位", prop: "notifyCmpId" }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  filterable: "",
                                  "default-value": _vm.form.notifyCmpId || "",
                                  "tag-name": "chineseName",
                                  "method-params": {
                                    customer: true,
                                    tradersSign: true,
                                    factorySign: true,
                                    collectionType: "or"
                                  }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.notifyCmpId = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "最早进仓时间",
                                prop: "warehouseInDateFrom"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.warehouseInDateFrom,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "warehouseInDateFrom",
                                      $$v
                                    )
                                  },
                                  expression: "form.warehouseInDateFrom"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "最晚进仓时间",
                                prop: "warehouseInDateTo"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.warehouseInDateTo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "warehouseInDateTo", $$v)
                                  },
                                  expression: "form.warehouseInDateTo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "仓库供应商", prop: "supplierId" }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  filterable: "",
                                  "default-value": _vm.form.supplierId || "",
                                  "tag-name": "chineseName",
                                  "method-params": { warehouse: true }
                                },
                                on: { parentCallBack: _vm.supplierChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "仓库名称",
                                prop: "warehouseUuid"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  cache: false,
                                  filterable: "",
                                  remote: true,
                                  url: _vm.URL.warehouseIn.queryWarehouseInfo,
                                  "default-value": _vm.form.warehouseUuid,
                                  "method-params": {
                                    supplierId: _vm.form.supplierId || ""
                                  },
                                  "remote-default-obj": {
                                    warehouse: _vm.form.warehouse,
                                    uuid: _vm.form.warehouseUuid
                                  },
                                  "tag-name": "warehouse",
                                  "tag-value": "uuid"
                                },
                                on: {
                                  parentCallBack: function(warehouse) {
                                    return _vm.warehouseCallback(warehouse)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "预计离港时间", prop: "etd" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.etd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "etd", $$v)
                                  },
                                  expression: "form.etd"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "仓库联系人",
                                prop: "warehouseContact"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.warehouseContact,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "warehouseContact", $$v)
                                  },
                                  expression: "form.warehouseContact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "联系电话",
                                prop: "warehouseContactTel"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.warehouseContactTel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "warehouseContactTel",
                                      $$v
                                    )
                                  },
                                  expression: "form.warehouseContactTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "仓库地址",
                                prop: "warehouseAddress"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.form.warehouseAddress,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "warehouseAddress", $$v)
                                  },
                                  expression: "form.warehouseAddress"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "进仓要求",
                                prop: "warehouseInRequirement"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.form.warehouseInRequirement,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "warehouseInRequirement",
                                      $$v
                                    )
                                  },
                                  expression: "form.warehouseInRequirement"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "进仓信息", name: 2 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "回执单号", prop: "receiptNo" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.receiptNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "receiptNo", $$v)
                                  },
                                  expression: "form.receiptNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "进仓状态",
                                prop: "state",
                                disabled: ""
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.state,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "state", $$v)
                                    },
                                    expression: "form.state"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "未进仓", value: 0 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "部分进仓", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "已全部进仓", value: 2 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "进仓异常", value: -1 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "送货公司", prop: "deliveryCmp" }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.deliveryCmp,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "deliveryCmp", $$v)
                                  },
                                  expression: "form.deliveryCmp"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "车牌号", prop: "truckNo" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.truckNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "truckNo", $$v)
                                  },
                                  expression: "form.truckNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "车辆类型", prop: "vehicleType" }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  cache: false,
                                  filterable: "",
                                  url: _vm.URL.warehouseIn.queryVehicleType,
                                  "default-value": _vm.form.vehicleType,
                                  "tag-name": "name",
                                  "tag-value": "code"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.vehicleType = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "司机", prop: "driver" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.driver,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "driver", $$v)
                                  },
                                  expression: "form.driver"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "司机电话", prop: "driverTel" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.driverTel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "driverTel", $$v)
                                  },
                                  expression: "form.driverTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注", prop: "remarks" } },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.form.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "remarks", $$v)
                                  },
                                  expression: "form.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "货物明细", name: 3 } },
                [
                  _c("cargo-detail", {
                    ref: "packageInfo",
                    attrs: {
                      "operation-type": _vm.oprationType,
                      "warehouse-in-uuid": _vm.warehouseInUuid,
                      "refresh-base-info": _vm.handleGetWarehouseInInfo
                    }
                  })
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "进仓照片", name: 4 } },
                [
                  _c("pic-list", {
                    attrs: {
                      "operation-type": _vm.oprationType,
                      "warehouse-in-uuid": _vm.warehouseInUuid
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }